import React from 'react';
import { Box, TextField, MenuItem } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

const PRESETS = {
  classic: {
    label: 'Classic (default)',
    defaultTier: 'BRONZE',
    defaultTierColor: '#CD7F32',
    tiers: [
      { name: 'PLATINUM', label: 'Platinum', color: '#E5E4E2', minOrders: 50, minSpent: 1500, order: 3 },
      { name: 'GOLD', label: 'Gold', color: '#FFD700', minOrders: 20, minSpent: 500, order: 2 },
      { name: 'SILVER', label: 'Silver', color: '#C0C0C0', minOrders: 5, minSpent: 100, order: 1 },
      { name: 'BRONZE', label: 'Bronze', color: '#CD7F32', minOrders: 0, minSpent: 0, order: 0 },
    ],
  },
  stars: {
    label: 'Stars',
    defaultTier: '1_STAR',
    defaultTierColor: '#9E9E9E',
    tiers: [
      { name: '5_STARS', label: '5 Stars', color: '#FFD700', minOrders: 50, minSpent: 1500, order: 4 },
      { name: '4_STARS', label: '4 Stars', color: '#C0C0C0', minOrders: 25, minSpent: 750, order: 3 },
      { name: '3_STARS', label: '3 Stars', color: '#CD7F32', minOrders: 10, minSpent: 250, order: 2 },
      { name: '2_STARS', label: '2 Stars', color: '#9E9E9E', minOrders: 3, minSpent: 50, order: 1 },
      { name: '1_STAR', label: '1 Star', color: '#757575', minOrders: 0, minSpent: 0, order: 0 },
    ],
  },
  vip: {
    label: 'VIP',
    defaultTier: 'REGULAR',
    defaultTierColor: '#9E9E9E',
    tiers: [
      { name: 'ELITE', label: 'Elite', color: '#E5E4E2', minOrders: 75, minSpent: 2500, order: 3 },
      { name: 'VIP', label: 'VIP', color: '#FFD700', minOrders: 35, minSpent: 1000, order: 2 },
      { name: 'PREFERRED', label: 'Preferred', color: '#C0C0C0', minOrders: 10, minSpent: 200, order: 1 },
      { name: 'REGULAR', label: 'Regular', color: '#9E9E9E', minOrders: 0, minSpent: 0, order: 0 },
    ],
  },
  simple: {
    label: 'Simple',
    defaultTier: 'NEW',
    defaultTierColor: '#9E9E9E',
    tiers: [
      { name: 'LOYAL', label: 'Loyal', color: '#FFD700', minOrders: 20, minSpent: 500, order: 2 },
      { name: 'RETURNING', label: 'Returning', color: '#C0C0C0', minOrders: 3, minSpent: 50, order: 1 },
      { name: 'NEW', label: 'New', color: '#9E9E9E', minOrders: 0, minSpent: 0, order: 0 },
    ],
  },
};

function addIds(tiers) {
  return (tiers || []).map((t) => ({ ...t, id: uuidv4() }));
}

function TierPresetSelector({ onSelectPreset }) {
  const handleChange = (event) => {
    const key = event.target.value;
    if (!key || !PRESETS[key]) return;
    const preset = PRESETS[key];
    onSelectPreset({
      tiers: addIds(preset.tiers),
      defaultTier: preset.defaultTier,
      defaultTierColor: preset.defaultTierColor,
    });
  };

  return (
    <Box sx={{ mb: 2 }}>
      <TextField
        select
        label="Start from preset"
        size="small"
        defaultValue=""
        onChange={handleChange}
        sx={{ minWidth: 220 }}
        SelectProps={{ displayEmpty: true }}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {Object.entries(PRESETS).map(([value, { label }]) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}

export default TierPresetSelector;
